module.exports = __webpack_public_path__ + "assets/register-v2.991e8af9.svg";